import { useParams, Navigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { projectsApi } from '../../lib/apiClient';

// Resolves an external deep-link of the form /projects/by-job/:jobNumber to
// PMT's internal /projects/:id workspace. The Safety Site only knows job
// numbers, so it links here; PMT's surrogate id stays private to PMT.
export default function ProjectByJobRedirect() {
  const jobNumber = useParams().jobNumber ?? '';
  const { data, isLoading, isError } = useQuery({
    queryKey: ['project-id-by-job', jobNumber],
    queryFn: () => projectsApi.idByJob(jobNumber),
    enabled: jobNumber.length > 0,
    retry: false,
  });

  if (isLoading) {
    return <div style={{ padding: 24 }}>Opening project {jobNumber}…</div>;
  }
  if (isError || !data) {
    return (
      <div style={{ padding: 24 }}>
        No project found in the Project Tracker for job number <strong>{jobNumber}</strong>.
      </div>
    );
  }
  return <Navigate to={`/projects/${data.id}`} replace />;
}
